import { BaseService } from 'core/services';
import NikoPatientRouteService from './NikoPatientRouteService';

class NikoPatientService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NikoPatientRouteService());
    }

    sync() {
        const url = this.routeService.sync();
        return this.apiClient.put(url);
    }

    updatePatientInformation(resource) {
        const url = this.routeService.updatePatientInformation(resource);
        return this.apiClient.put(url, resource);
    }

    rentalsCapped(resource) {
        const url = this.routeService.rentalsCapped(resource);
        return this.apiClient.put(url, resource);
    }

    hasIvpole(resource) {
        const url = this.routeService.hasIvpole(resource);
        return this.apiClient.put(url, resource);
    }
    
    checkExisting(resource) {
        const url = this.routeService.checkExisting(resource);
        return this.apiClient.post(url, resource);
    }

    resolveScenario(resource) {
        const url = this.routeService.resolveScenario(resource);
        return this.apiClient.post(url, resource);
    }

    createWithTemplates(resource) {
        const url = this.routeService.createWithTemplates(resource);
        return this.apiClient.post(url, resource);
    }

    getExistingInsurance(id) {
        const url = this.routeService.getExistingInsurance(id);
        return this.apiClient.get(url);
    }
}

export default NikoPatientService;